import axios from "axios";

export default function SafetyemployeeByemployeeListService(emloyeeId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/safety/employee/" + emloyeeId + "/by-employee",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
